// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3NHNa","validationTips":"StatementDescriptor_validationTips__1BrL8"};